import { render, staticRenderFns } from "./allScanPeopleInfoDialog.vue?vue&type=template&id=7b81c1aa&scoped=true"
import script from "./allScanPeopleInfoDialog.vue?vue&type=script&lang=js"
export * from "./allScanPeopleInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./allScanPeopleInfoDialog.vue?vue&type=style&index=0&id=7b81c1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b81c1aa",
  null
  
)

export default component.exports